import {
    getPermissionsByUser,
    getAllUsersWithDetails,
    getAllRoles,
    saveUser,
    getUserById,
    getCompetencesByUser
} from './user';
import { getAllPlanned, GetScannerDetail, GetPickingDetail } from './pickingOverviewService';
import { getPlanned, sendCarrierByBarcode } from './pickingOverviewService';
import { getAllPaused } from './pickingOverviewService';
import { sendValidateUser } from './user';

import { sendChangeCarrier } from './scannerService';
import { getPickStock } from './pickingDetailService';
import { getByCarrier, sendPauseWorkflow, sendFinishWorkflow, getByCarrierBarcode } from './pickingDetailService';
export const dataService = {
    getAllPlanned,
    getPlanned,
    sendCarrierByBarcode,
    getAllPaused,
    sendValidateUser,
    getPermissionsByUser,
    getPickStock,
    sendChangeCarrier,
    getByCarrier,
    sendPauseWorkflow,
    sendFinishWorkflow,
    getAllUsersWithDetails,
    getAllRoles,
    saveUser,
    getUserById,
    getCompetencesByUser,
    getByCarrierBarcode,
    GetScannerDetail,
    GetPickingDetail
};